import { ClientActivity, ConflictMessage } from "../shell"
import { IOmniaCommand, StringLike } from "../types"
import { isFunction } from "../utils/utils"
import { GlobalFilter, IComponentContext } from "./types"

export class Component {

    protected _rootElement: Element

    protected componentContext: IComponentContext;
    protected execArguments: any;
    protected _icon: string;
    protected _title: StringLike;
    protected _commands: IOmniaCommand[];
    protected _pinnable: boolean;
    protected _filter: GlobalFilter

    protected _width: number;

    private _activity: ClientActivity
    private _conflict: ConflictMessage

    private _dispose: Function[] = []

    constructor(protected $scope: ng.IScope, setupWatchGroup?: string[]) {

        if (setupWatchGroup && setupWatchGroup.length) {

            $scope.$watchGroup(["vm.componentContext"].concat(setupWatchGroup), () => this.setupContext());

        }
        else {

            $scope.$watch("vm.componentContext", () => this.setupContext());

        }

    }

    $onDestroy() {

        const disposable = this._dispose
        this._dispose = undefined

        for (const d of disposable) {
            d()
        }

        this.setActivity(undefined)

        this.dispose()

    }

    protected dispose() {
        // NOP
    }

    protected addDisposable(disposable: Function) {
        if (isFunction(disposable)) {
            this._dispose.push(disposable)
        }
    }

    private setupContext() {

        var ctxt = this.componentContext;
        this.execArguments = (ctxt ? ctxt.execArguments : null);

        if (ctxt) {
            this.componentContext.component = this;
            this.setup();
        }

    }

    protected setup() {
        // NOP
    }

    get commands(): IOmniaCommand[] {
        return this._commands;
    }

    set commands(value: IOmniaCommand[]) {
        this._commands = value;
    }

    get icon(): string {
        return this._icon;
    }

    get title() {
        return this._title;
    }

    get globalFilter() {
        return this._filter
    }

    get width(): number {
        return this._width;
    }

    get pinnable(): boolean {
        return this._pinnable;
    }

    get activity() {
        return this._activity
    }

    protected setActivity(activity: ClientActivity) {
        this._activity = activity
    }

    get conflict() {
        return this._conflict
    }

    protected setConflict(conflict: ConflictMessage) {
        this._conflict = conflict
    }

    isActive(): boolean {
        return this.componentContext?.isActive()
    }

    onClose() {
        return this.componentContext?.result
    }

    canClose(): boolean {
        return (this.componentContext && this.componentContext.canClose());
    }

    closeComponent(result?: any) {
        this.componentContext.close(result);
    }

    cancel() {
        this.closeComponent();
    }

    protected scrollItemIntoView(query: string, options: boolean | ScrollIntoViewOptions = true) {

        if (this._rootElement) {

            const target = this._rootElement.querySelector(query)

            if (target) {
                target.scrollIntoView(options)
                return true
            }

        }

    }


    private _ignoreNextRefresh = false

    protected setupAutoRefresh(refresh: () => any, runNow = false, watch: string = "vm.svc.stateVersion") {

        this.$scope.$watch(watch, (a, b) => {

            if (this._ignoreNextRefresh) {
                this._ignoreNextRefresh = false
            }
            else if (runNow || (a !== b)) {

                return refresh()

            }

        })

    }

    protected ignoreNextRefresh() {
        this._ignoreNextRefresh = true
    }

}


export class UpdatableComponent extends Component {

    refresh(auto: boolean): PromiseLike<any> {
        // NOP
        return undefined
    }

}
